import React, { useState } from 'react'
import { Modal, OverlayTrigger, Row, Col } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import AppFormikInputFieldRadio from 'utlis/helpers/forms/AppFormikInputFieldRadio';
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'


function CategoryRow({ item, category, index, getProducts_, selectedCategory }) {
    const [expend, setExpend] = useState(false)
    return (
        <div key={item.category_id}>
            <div
                className={` category-item ${!expend && category !== item.category_id ? "" : "selected-category"}`}
                onClick={e => {
                    if (item.sub_categories && item.sub_categories.length > 0) {
                        setExpend(!expend)
                    }
                    getProducts_(item.category_id)

                    selectedCategory(item.category_id)
                }}>
                <FeatherIcon
                    icon="folder"
                    size="14"
                    className="icon me-1" />
                <span>{item.category_name}</span>
                {(item.sub_categories && item.sub_categories.length > 0) && <FeatherIcon
                    icon={`${expend ? "minus" : "plus"}`}
                    size="14"
                    className="icon ms-2" />
                }
            </div>
            {expend && item.sub_categories && item.sub_categories.map((subItem, index) =>
                <div className="pad-15-L" key={index}>
                    <div
                        className={` category-item ${category !== subItem.category_id ? "" : "selected-category"}`}
                        onClick={e => {
                            getProducts_(subItem.category_id)
                            selectedCategory(subItem.category_id)
                        }}>
                        <FeatherIcon
                            icon="folder"
                            size="14"
                            className="icon me-1" />
                        <span>{subItem.category_name}</span>
                    </div>
                </div>
            )}
        </div>

    )
}

function ProductRow({ item, selectedProducts, index, setSelectedProducts, lines }) {
    const [selected, setSelected] = useState(item.selected || lines.filter(e => (e.variant_sku || e.variant_sku) === (item.variant_sku || item.variant_sku)).length > 0)
    return (
        <div className="d-flex align-items-center justify-content-between pad-15-R pad-15-L product-hover"
            key={item.product_id + "" + index}>
            <div className="sale-product">
                <AppFormikInputFieldRadio
                    id={item.variant_sku || item.sku}
                    value={selected}
                    checked={selected}
                    stFormClass={`st-form st-form-with-label-left d-flex flex-wrap align-items-center justify-content-left ${selected ? "text-primary" : ""}`}
                    formikFieldName={"" + item.product_id}
                    labelNameRight={item.product_name}
                    isDisabled={(item.variant_stock || item.stock) === 0}
                    onChange={(e) => {
                        setSelected(!selected)
                        const array = selectedProducts
                        item.selected = e.target.checked
                        array[index] = item
                        setSelectedProducts(arr => array)
                    }}
                />
                <div className="variant_sku">{item.variant_sku || item.sku}</div>
                <div className="variant">{item.variant}</div>
            </div>
            <div className={`st-fs-12 ${(item.variant_stock || item.stock) === 0 ? "text-danger" : "text-success"}`} >
                {(item.variant_stock || item.stock) === 0 ? "out of stock" : "Stock: " + (item.variant_stock || item.stock)}
            </div>
        </div>
    )

}

export default function AddNewProductModal(props) {
    const { show, closeModal, getProducts_, selectedProducts, label, filterCategories, foundCategory, filterProduct, foundProducts, setLines } = props
    const [category, selectedCategory] = useState(false)
    return (
        <Modal show={show} onHide={closeModal} centered size="lg">
            <Modal.Body className="st-modal pad-20">
                <div className="app-modal-content modal-add-product p-0">
                    <div className="add-product-form">
                        <div className="d-flex justify-content-between">
                            <div className="app-modal-title-wrapper mb-2 mb-lg-3 p-0">
                                <p className="app-modal-title st-fw-600 st-fs-24">Select a product using the search below</p>
                            </div>
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={renderTooltipClose}
                            >
                                <button
                                    className="st-round-btn st-btn-transparent  st-btn-sm d-flex align-items-center justify-content-center"
                                    onClick={closeModal && closeModal}
                                >
                                    <FeatherIcon
                                        icon="x"
                                        size="24"
                                        className="icon border st-default-rounded-block" />
                                </button>
                            </OverlayTrigger>
                        </div>
                        <div className="app-card" id="browse-category-modal">
                            <div className="app-card-content border st-default-rounded-block pad-20">
                                <div className="st-form flex-wrap mb-0">
                                    <div className="app-card-content st-border-light align-items-center">
                                        <Row className="align-items-center">
                                            <div className="app-card mb-3 mb-lg-4" id="categories">
                                                <Row>
                                                    <Col xs={12} md={9} lg={12} className="px-0">
                                                        <div className="app-header-wrapper heading-sm mb-3 pad-12-L">
                                                            <p className="app-heading text-capitalize">Search by Category</p>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <div className="app-card-content-category border st-border-light st-default-rounded-block">
                                                    <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0" >
                                                        <label className="d-none st-label-with-left me-2" value={label}>Search</label>

                                                        <input type="text" className="form-control" placeholder="Category Name" onChange={filterCategories} />
                                                        <div className="icon">
                                                            <FeatherIcon
                                                                icon="search"
                                                                size="15"
                                                                className="icon-main" />
                                                        </div>
                                                    </div>

                                                    <div className="app-card-content st-border-light category-content">
                                                        {(foundCategory && foundCategory.length > 0) && foundCategory.map((item, index) => {
                                                            return (
                                                                <CategoryRow item={item}
                                                                    key={index}
                                                                    index={index}
                                                                    category={category}
                                                                    getProducts_={getProducts_}
                                                                    selectedCategory={selectedCategory}
                                                                />
                                                            )
                                                        })}
                                                    </div>


                                                </div>
                                            </div>
                                            <div id="icon">
                                                <div className="center-icon">
                                                    <FeatherIcon
                                                        icon="arrow-right"
                                                        size="30"
                                                        className="icon" />
                                                </div>
                                            </div>
                                            <div className="app-card mb-3 mb-lg-4" id="product">
                                                <Row>
                                                    <Col xs={12} md={9} lg={12} className="px-0">
                                                        <div className="app-header-wrapper heading-sm mb-0 pad-12-L">
                                                            <p className="app-heading text-capitalize">Search by Product Name</p>
                                                        </div>
                                                        <p className="product-count">Selected n Products below</p>
                                                    </Col>
                                                </Row>
                                                <div className="app-card-content-product border st-border-light st-default-rounded-block">
                                                    <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0">
                                                        <input type="text" className="form-control" placeholder="Product Name" onChange={filterProduct} />
                                                        <div className="icon">
                                                            <FeatherIcon
                                                                icon="search"
                                                                size="15"
                                                                className="icon-main" />
                                                        </div>
                                                    </div>
                                                    <div className="heading-sm  pad-12-T product-item">
                                                        {(foundProducts && foundProducts.length > 0) && foundProducts.map((item, index) =>
                                                            <div key={index}>
                                                                <ProductRow item={item} {...props} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                    </div>

                                    <div className="app-card-content st-border-light d-flex align-items-center justify-content-end">
                                        <button
                                            type="button"
                                            className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2 min-height-auto`}
                                            // disabled={createButtonDisable}
                                            onClick={() => {
                                                closeModal()
                                            }}
                                        >
                                            <FeatherIcon
                                                icon="rotate-ccw"
                                                size="14"
                                                className="icon me-1" />
                                            <span>Reset</span>
                                        </button>
                                        <button
                                            type="submit"
                                            // className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                            className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center min-height-auto`}
                                            // disabled={createButtonDisable}
                                            onClick={() => {
                                                setLines(arr => [...arr, ...selectedProducts.filter(e => e.selected)].filter(e => e.product_name))
                                                closeModal()
                                            }}
                                        >
                                            <FeatherIcon
                                                icon="download"
                                                size="14"
                                                className="icon me-1" />
                                            {
                                                // createButtonLoading ? (
                                                //     <Spinner animation="border" size="sm" />
                                                // ) : (
                                                <span>Save</span>
                                                // )
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            // modalLoading && (
                            // <div className="app-modal-loading-overlay position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                            //     <Spinner animation="border" />
                            // </div>
                            // )
                        }
                    </div>
                </div>
            </Modal.Body >
        </Modal >)
}
